var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "section",
    {
      staticClass: "cw-structural-element-comments",
      class: [_vm.emptyComments ? "cw-structural-element-comments-empty" : ""],
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.emptyComments,
              expression: "!emptyComments",
            },
          ],
          ref: "commentsRef",
          staticClass: "cw-structural-element-comments-items",
        },
        _vm._l(_vm.comments, function (comment) {
          return _c("courseware-talk-bubble", {
            key: comment.id,
            attrs: {
              payload: _vm.buildPayload(comment),
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-structural-element-comment-create",
        },
        [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.createComment,
                expression: "createComment",
              },
            ],
            attrs: {
              placeholder: _vm.placeHolder,
              spellcheck: "true",
            },
            domProps: {
              value: _vm.createComment,
            },
            on: {
              input: function input($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.createComment = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button",
              on: {
                click: _vm.postComment,
              },
            },
            [_c("translate", [_vm._v("Senden")])],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }